<template>
  <div style="position: relative">
    <div class="wf-page-controls">
      <button
            type="button"
            class="d-inline-flex btn btn-sm btn-light"
            @click="handleBack"
            aria-label="Back"
          >
            <span
              class="png-icon png-icon-icons-glyph--k-arrow-left-sm d-lg-inline"
            >
            </span>
            <span class=" d-lg-inline pl-1">
              {{ $resourceString["common.Button.ReturnBack.Label"] }}
            </span>
      </button>
      <div class="wf-page-controls-items">
        <div class="wf-page-control-item wf-page-control-item-current-refinements">
          <pc-vt-search-current-filters />
        </div>
      </div>
    </div>
    <div id="outer-wrapper" @mousedown.left="unmouseStuff">
      <div id="outer-container">
        <header data-html2canvas-ignore="true" class="my-4">
          <div class="virtual-tray-search">
            <div class="input-group border border-light mb-3">
              <div class="input-group-prepend">
                <button tabindex="-1" type="submit" class="btn bg-white px-1">
                  <Icon icon="simple-line-icons:magnifier" :color="'#B6BBCF'" :width="'15'" />
                </button>
              </div>
              <input type="search" class="form-control border-0" placeholder="search collection, style, color, #"
                @input="searchInput" :value="searchTerm" />
            </div>
          </div>
          <div class="row w-100 px-3">
            <div class="col-9 px-0">
              <div class="row justify-content-md-start d-flex">
                <div class="hide-on-mobile-tablet" :class="!trayId
                    ? 'col-lg-3 col-md-6 my-1'
                    : 'col-lg-3 col-md-auto my-1'
                  ">
                  <button class="btn btn-outline-primary vt-dwonload-spec-hover h-100 w-100" @click="downloadTrayImage">
                    {{ $resourceString["virtualtray.download.tray"] }}
                    <span class="png-icon png-icon-icons-glyph--g-btn-download"></span>
                  </button>
                </div>
                <div :class="!trayId
                    ? 'col-lg-3 col-md-5 my-1'
                    : 'col-lg-3 col-md-6 my-1'
                  ">
                  <button class="btn btn-outline-primary h-100 w-100" @click="downloadSpecs">
                    {{ $resourceString["virtualtray.download.specs"] }}
                    <span class="png-icon png-icon-icons-glyph--g-btn-download"></span>
                  </button>
                </div>
                <div :class="!trayId
                    ? 'col-lg-3 col-md-5 my-1'
                    : 'col-lg-3 col-md-6 my-1'
                  " v-if="isAdminMode">
                  <button class="btn btn-outline-primary h-100 w-100" @click="downloadTrayJson">
                    {{ $resourceString["Virtualtray.Download.Tray.Json"] }}
                  </button>
                </div>
                <div :class="!trayId
                    ? 'col-lg-3 col-md-5 my-1'
                    : 'col-lg-3 col-md-5 my-1'
                  ">
                  <button class="btn btn-outline-primary h-100 w-100" :class="{ disabled: isDisabled }" @click="shareTray"
                    :disabled="isDisabled">
                    {{ $resourceString["virtualtray.Sharetray.Header"] }}
                    <span class="png-icon png-icon-icons-glyph--g-share"></span>
                  </button>
                </div>
                <div :class="!trayId
                    ? 'col-lg-3 col-md-5 my-1'
                    : 'col-lg-3 col-md-6 my-1'
                  " @click="saveTray">
                  <button class="btn btn-outline-primary h-100 w-100" :href="saveTrayHref" ref="saveTrayHref">
                    {{ $resourceString["virtualtray.Savetray.Header"] }}
                    <svg fill="darkgray" class="ml-2" style="height: 26px; width: 22px;"
                      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                      <!--! Font Awesome Pro 6.4.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. -->
                      <path
                        d="M48 96V416c0 8.8 7.2 16 16 16H384c8.8 0 16-7.2 16-16V170.5c0-4.2-1.7-8.3-4.7-11.3l33.9-33.9c12 12 18.7 28.3 18.7 45.3V416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V96C0 60.7 28.7 32 64 32H309.5c17 0 33.3 6.7 45.3 18.7l74.5 74.5-33.9 33.9L320.8 84.7c-.3-.3-.5-.5-.8-.8V184c0 13.3-10.7 24-24 24H104c-13.3 0-24-10.7-24-24V80H64c-8.8 0-16 7.2-16 16zm80-16v80H272V80H128zm32 240a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-12 col-md-3 my-1">
              <div class="row justify-content-lg-end">
                <div class="col-auto order-samples w-auto " @click="addToBasketClick"
                :style="{ 'pointer-events': OrderSampleEnabled ? 'none' : 'auto', 'background-color': OrderSampleEnabled ? '#ccc' : '' }"
                :class="{ disabled: OrderSampleEnabled }">
                  <span  href="#order" class="png-icon png-icon-icons-glyph--ko-my-basket mr-2" style="cursor: pointer;"></span>
                  <a  href="#order" class="pt-1 text-light text-decoration-none">
                    {{ $resourceString["virtualtray.add.tray.to.basket"] }}</a>
                </div>

                <div class="mt-3 start-over text-left text-nowrap">
                  <a @click.stop="openStartOverModal" class="text-underline" role="button">
                    {{ $resourceString["virtualtray.start.over"] }}
                    <Icon icon="dashicons:image-rotate" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </header>

        <div class="d-flex mt-1 mb-4 mr-4">
          <div data-html2canvas-ignore="true" class="wf-product-category-sidebar-desktop">
            <!--   uncomment button tag if wanted premix tray dropdown in vt page -->
            <a class="btn btn-white shadow-sm w-100 mt-3 btn-xs shadow-sm" href="/Account/MyTrays?tab=premix">
              <span>{{ $resourceString["virtualtray.premixes.trays"] }}</span>
              <!-- <Icon icon="clarity:caret-line" :rotate="2" height="1.5em" /> -->
            </a>
            <button class="btn btn-white shadow-sm w-100 btn-xs mt-3 shadow-sm" @click="openFiltersModal">
              <span>{{ $resourceString["virtualtray.all.filters"] }}</span>
              <Icon icon="ion:options-outline" :rotate="2" height="1.5em" aria-hidden="true" />
            </button>
            <div class="results-container mt-4">
              <pc-infinity-hits ref="childref" @onResultClick="processSlideEvent" data-html2canvas-ignore="true" />
              <pc-load-more v-if="showLoadMore" :load-more="onLoadMore" />
            </div>
          </div>
          <div class="w-100 d-flex justify-content-between align-items-center">
            <div class="bottom-container">
              <div>
                <div v-if="modalShownBool && (!showLoaderOnTrayZone)" class="welcome-msg welcome-msg-sm">
                  <pc-welcome-msg />
                </div>
                <pc-load-more v-if="(showLoaderOnTrayZone)" :load-more="() => {}" />
                <pc-tray-tiles v-if="(!showLoaderOnTrayZone)" @startDrag="startDrag" @trayDeleteItem="trayDeleteItem" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--#outer-container-->

      <!-- Delete item modal-->
      <modal name="remove-item-confirm-modal" height="auto">
        <pc-confirm-modal :header="$resourceString['virtualtray.delete.item.confirm.header']" :subheader="$resourceString['virtualtray.delete.item.confirm.subheader']
          " :close="closeRemoveModal" :confirm="confirmRemove" :adaptive="true" :hidePopup="true" />
      </modal>
      <!--Start Over confirm modal -->
      <modal name="start-over-confirm-modal" height="200" :adaptive="true">
        <template>
          <pc-confirm-modal :header="$resourceString['virtualtray.start.over.confirm.header']" :subheader="$resourceString['virtualtray.start.over.confirm.subheader']
            " :close="closeStartOverModal" :confirm="confirmStartOver" :hidePopup="false" />
        </template>
      </modal>
      <!--Premixes confirm modal -->
      <modal name="premixes-confirm-modal" height="200" :adaptive="true">
        <pc-confirm-modal :header="$resourceString['virtualtray.replace.confirm.header']" :subheader="$resourceString['virtualtray.replace.confirm.subheader'] +
          ' ' +
          premix.name +
          '?'
          " :close="closePremixesConfirmModal" :confirm="processPremixClick" :hidePopup="false" />
      </modal>
      <!--Add to cart confirm modal -->
      <modal name="add-to-cart-confirm-modal" height="350" :adaptive="true">
        <pc-confirm-modal :header="$resourceString['virtualtray.add.to.basket.confirm.header']" :subheader="$resourceString['virtualtray.add.to.basket.confirm.subheader']
          " :close="closeAddToBasketConfirm" :confirm="addToBasket" :hidePopup="false" />
      </modal>
      <!--Too much carpets -->
      <modal name="too-much-items-alert-modal" height="250" :adaptive="true">
        <pc-alert-modal :header="$resourceString['virtualtray.too.much.items.alert.header']" :subheader="$resourceString['virtualtray.too.much.items.alert.subheader']
          " :close="closeTooMuchAlertModal" />
      </modal>
      <!--no items to add to cart -->
      <modal name="no-items-for-cart-alert-modal" height="200" :adaptive="true">
        <pc-alert-modal :header="$resourceString['virtualtray.no.items.alert.header']"
          :subheader="$resourceString['virtualtray.no.items.alert.subheader']" :close="closeNoItemsForCart" />
      </modal>
      <!--no items to download tray -->
      <modal name="no-items-to-download-modal" height="200" :adaptive="true">
        <pc-alert-modal :header="$resourceString['virtualtray.no.items.alert.header']" :subheader="$resourceString['virtualtray.no.items.to.download.subheader']
          " :close="closeNoItemsForDownload" />
      </modal>
      <!-- Download Spec Modal -->
      <modal name="download-specs-modal" data-html2canvas-ignore="true" :adaptive="true">
        <pc-download-specs-modal />
      </modal>
      <!-- Save Tray -->
      <modal :max-height="450" height="500" name="save-tray-modal" data-html2canvas-ignore="true" :scrollable="true"
        :adaptive="true">
        <pc-vt-save-tray-modal :boardDetails="boardDetails" :trayId="trayId" :isAdminMode="user ? user.isAdmin : false"
          :user="user ? user.user : null"></pc-vt-save-tray-modal>
      </modal>
      <!-- Share Tray -->
      <modal height="650" name="share-tray-modal" data-html2canvas-ignore="true" :adaptive="true" :scrollable="true">
        <pc-vt-share-tray-modal :userEmail="user.user ? user.user.email : ''"></pc-vt-share-tray-modal>
      </modal>
      <modal height="650" name="upload-image-modal">
        <pc-vt-upload-image-modal :user="user"></pc-vt-upload-image-modal>
      </modal>
      <!--Filters modal -->
      <modal :adaptive="true" v-show="isFiltersModalOpened" name="filters-modal" @before-close="hideFiltersModal"
        :scrollable="true" height="500" :max-height="600" data-html2canvas-ignore="true">
        <div class="p-3 ml-3 mt-3 pr-5 filters-wrapper">
          <pc-vt-side-filters/>
        </div>
        <button class="wf-modal-button-close btn button-full" type="button" @click="closeFiltersModal">
          <span class="png-icon png-icon-icons-symbols--k-txtclose" aria-label="Close modal" />
        </button>
      </modal>

      <!-- Premixes modal -->
      <modal :adaptive="true" name="premixes-modal" class="premixes-modal-z-index" width="700" height="500"
        data-html2canvas-ignore="true" :scrollable="true">
        <pc-premixes-modal @onPremixClick="confirmReplaceToPremix" />
        <button class="wf-modal-button-close btn button-full" type="button" @click="closePremixesModal">
          <span class="png-icon png-icon-icons-symbols--k-txtclose" aria-label="Close modal" />
        </button>
      </modal>
      <modal name="redirect-confirm-modal" height="auto">
        <pc-redirect-confirm-modal :header="$resourceString['accounts.Virtualtray.Redirect.Confirm.HeaderFirst']" :subheader="$resourceString['accounts.Virtualtray.Redirect.Confirm.Header']"
       :close="closeRedirectModal"  :adaptive="true" :hidePopup="true" />
      </modal>
    </div>
    <pc-vt-download />
  </div>

  <!--#outer-wrapper-->
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  import PcVtSideFilters from "./pc-vt-side-filters.vue";
  import PatcraftApi from "../../../scripts/patcraft-api";
  import LZString from "lz-string";
  import cookies from "cookiesjs";
  import { Icon } from "@iconify/vue2";
  import PcInfinityHits from "./pc-vt-infinity-hits.vue";
  import PcPremixesModal from "./pc-vt-premixes-modal.vue";
  import PcDownloadSpecsModal from "./pc-vt-download-specs-modal.vue";
  import PcConfirmModal from "./pc-vt-confirm-modal.vue";
  import pcWelcomeMsg from "./pc-vt-welcome-msg.vue"
  import PcAlertModal from "./pc-vt-alert-modal.vue";
  import PcTrayTiles from "./pc-vt-tray-tiles.vue";
  import PcVtDownload from "./pc-vt-download.vue";
  import html2canvas from "html2canvas";
  import FileSaver from "file-saver";
  import PcVtSearchCurrentFilters from "./pc-vt-search-current-filters.vue";
  import PcLoadMore from "../common/pc-loading-more.vue";
  import PcVtSaveTrayModal from "./pc-vt-save-tray-modal.vue";
  import PcVtShareTrayModal from "./pc-vt-share-tray-modal.vue";
  import pcVtUploadImageModal from "./pc-vt-upload-image-modal.vue";
  import PcRedirectConfirmModal from "./pc-vt-redirect-confirm-modal.vue";


  export default {
    props: ["user", "boardDetails"],

    components: {
      Icon,
      PcInfinityHits,
      PcPremixesModal,
      PcDownloadSpecsModal,
      pcWelcomeMsg,
      PcConfirmModal,
      PcAlertModal,
      PcTrayTiles,
      PcVtSideFilters,
      PcVtSearchCurrentFilters,
      PcLoadMore,
      PcVtSaveTrayModal,
      PcVtShareTrayModal,
      pcVtUploadImageModal,
      PcVtDownload,
      PcRedirectConfirmModal
    },
    data() {
      return {
        modalShownBool:true,
        isAdminMode: false,
        swatchTileSizeRatio: 25,
        selectedId: "",
        premix: "",
        showLoaderOnTrayZone: false,
        timeout: null,
        // eslint-disable-next-line max-len
        carbonAzureName: "Sustainability",
        trayId: null,
        httpReferer: ''
      };
    },
    methods: {
      ...mapActions({
        setFiltersModalOpened: "virtualTray/setFiltersModalOpened",
        trayOrderAddItem: "virtualTray/trayOrderAddItem",
        trayOrderDeleteItem: "virtualTray/trayOrderDeleteItem",
        trayDataAddItem: "virtualTray/trayDataAddItem",
        newDataAddedInTray: "virtualTray/newDataAddedInTray",
        trayDataEditDeleteItem: "virtualTray/trayDataEditDeleteItem",
        trayDataDeleteItem: "virtualTray/trayDataDeleteItem",
        loadTray: "virtualTray/loadTray",
        startOver: "virtualTray/startOver",
        toggleSelectedTile: "virtualTray/toggleSelectedTile",
        addNotification: "notifications/add",
        fetchResults: "virtualTray/fetchResults",
        setSearchTerm: "filters/setSearchTerm",
        resetSearchCriterias: "filters/resetSearchCriterias",
        setPageNumber: "virtualTray/setPageNumber",
        setFiltersFromURL: "filters/setFiltersFromURL",
        setFiltersInURL: "filters/setFiltersInURL",
        fetchPremixes: "virtualTray/fetchPremixes",
        getUserTrayIdApiDetails: "myTray/getUserTrayIdApiDetails",
        userInfoDetails: "myTray/userInfoDetails",
        newDataDeltededFromTray: "virtualTray/newDataDeltededFromTray",
        trayDataEditAddItem: "virtualTray/trayDataEditAddItem",
        UpdatetrayEditId: "myTray/UpdatetrayEditId",
        isOrderSampleEnabled: "productDetail/isOrderSampleEnabled",
        saveTrayForShare: "myTray/saveTrayForShare",
        updateTrayItemPosition: "virtualTray/updateTrayItemPosition",
        clearDownloadDataTrayData: "virtualTray/clearDownloadDataTrayData",
        fetchTrayDetails: "myTray/fetchTrayDetails",
        duplicateSwatchErrMsg: "myTray/duplicateSwatchErrMsg",
        updateCartCountInHeader: "virtualTray/updateCartCountInHeader",
        updateCommonErrorMsg:"myTray/updateCommonErrorMsg"

      }),

      handleBack(){
        window.location.href = this.httpReferer;
      },

      saveTrayHref() {
        if (!this.user?.user?.email || this.user?.user?.email === undefined) {
          window.location.href = `/Account/SignUpOrSignIn?returnUrl=/VirtualTray`;
        } else {
          this.showModal("save-tray");
        }
      },
      searchInput(e) {
        if (this.timeout) clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          const searchTerm = e.target.value?.trim();
          this.setSearchTerm(searchTerm);
        }, 1000);
      },
      addToBasketClick() {
        if (!Object.keys(this.trayData).length) {
          this.showNoItemsForCart();
          return;
        }

        const trayCartToken = cookies("traycart");
        if (trayCartToken) {
          this.showModal("add-to-cart-confirm");
        } else {
          this.addToBasket();
        }
      },
      closeAddToBasketConfirm() {
        this.hideModal("add-to-cart-confirm");
      },
      showNoItemsForCart() {
        this.showModal("no-items-for-cart-alert");
      },
      closeNoItemsForCart() {
        this.hideModal("no-items-for-cart-alert");
      },
      showNoItemsForDownload() {
        this.showModal("no-items-to-download");
      },
      closeNoItemsForDownload() {
        this.hideModal("no-items-to-download");
      },
      addToBasket() {
        const self = this;
        self.closeAddToBasketConfirm();
        const data = []
        let vehicleIdZeroCount = [];
        Object.values(this.trayData)?.map(item => {
            data.push({
              sellingStyleNumber: item.sellingStyleNumber,
              sellingColorNumber: item.colorNumber,
              quantity: 1.0,
              vehicleId: item.vehicleId,
              isTrayItem: true,
              imageLink: item.imageLink,
              colorName: item.colorName,
              colorNumber: item.colorNumber,
              isFeatureImage: item.isFeatureImage
            })
          if(Number(item.vehicleId) === 0) {
            vehicleIdZeroCount.push({
              sellingStyleNumber: item.sellingStyleNumber,
              sellingColorNumber: item.colorNumber,
              vehicleId: item.vehicleId
            })
          }
        });          
        PatcraftApi.addTrayItemsToCart(data)
          .then(res => {
            let result = res.data
            if(typeof res.data === 'string') {
              let cleanedData = res.data.replace(/,/, ""); 
              result = JSON.parse(cleanedData)
            }
            self.addLinkWithIndicator();
            let basketCount = result && result.find(i => i.basketCount)
                ? result.find(i => i.basketCount).basketCount
                : null;
            this.updateCartCountInHeader(basketCount);
            const vehicleIdSuccessItems = result && result.filter(item => Object.keys(item).indexOf('basketCount') === -1);
            const vehicleIdZeroFailItems = vehicleIdZeroCount.filter((item) => {
              if(!result.some((isCart) => ((isCart.sellingColorNumber === item.sellingColorNumber) && (isCart.sellingStyleNumber === item.sellingStyleNumber)))) {
                return true
              } else {
                return false
              }
            })
            if(vehicleIdZeroFailItems.length > 0 && vehicleIdSuccessItems.length === 0) {
                self.addNotification({
                  type: "error",
                  title: self.$resourceString["virtualtray.basket.vehicleid.error.title"],
                  description: `${vehicleIdZeroFailItems.length} ${self.$resourceString["virtualtray.basket.vehicleid.error"]}`
                });
            } else {
              self.addNotification({
                type: "success",
                title: self.$resourceString["virtualtray.basket.updated.title"],
                description: `${vehicleIdSuccessItems.filter(i => i.quantity !== undefined).length
                  } ${self.$resourceString["virtualtray.basket.updated.description"]}, ${vehicleIdZeroFailItems.length > 0 ? `${vehicleIdZeroFailItems.length} ${self.$resourceString["virtualtray.basket.vehicleid.error"]}` : ""}`
              });
            }           
            if(vehicleIdSuccessItems && vehicleIdSuccessItems.find(i => i.error)) {
                self.addNotification({
                  type: "warning",
                  title: "Basket updated",
                  description: vehicleIdSuccessItems.find(i => i.error).error
                });
            }              
          })
          .catch(function (error) {
            self.addNotification({
              type: "error",
              title: "Alert",
              description: self.$resourceString["virtualtray.basket.nodata.error"]
            });
        });
        
      },
      addLinkWithIndicator() {
        let basketIcon = document.querySelector(
          "#header .nav-top-secondary-desktop .nav-top-customer-link-with-number-indicator-empty"
        );

        if (!basketIcon) return;

        basketIcon.classList.replace(
          "nav-top-customer-link-with-number-indicator-empty",
          "nav-top-customer-link-with-number-indicator"
        );
      },
      downloadSpecs() {
        this.showModal("download-specs");
      },
      saveTray() {
        this.saveTrayHref();
      },
      shareTray() {
        if (!this.user?.user?.email || this.user?.user?.email === undefined) {
          window.location.href = `/Account/SignUpOrSignIn?returnUrl=/VirtualTray`;
        } else if (!this.trayId) {
          this.saveTrayForShare(
            this.$resourceString["virtualtray.Sharetray.Shared.Validation"]
          );
        } else {
          this.showModal("share-tray");
        }
      },
      getBase64Image(src, id) {
        if (!src) {
          return;
        }
        if (src != null && src != "null") {
          if (src.includes("?")) {
            src = src + "&";
          } else {
            src = src + "?";
          }
        }

        return new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = "anonymous";
          img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            let dataURL;
            canvas.height = img.naturalHeight;
            canvas.width = img.naturalWidth;
            ctx.drawImage(img, 0, 0);
            dataURL = canvas.toDataURL();
            if (dataURL) {
              document.getElementById(
                id
              ).style.backgroundImage = `url('${dataURL}')`;
              resolve(dataURL);
            }
          };

          if (src) img.src = src;
          if (img.complete || img.complete === undefined) {
            img.src =
              "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
            img.src = src;
          }
          img.onerror = error => {
            reject(error);
          };
        });
      },
      inlineImages() {
        const imgs = Object.keys(this.trayData).map(id =>
          this.getBase64Image(this.trayData[id].backgroundTileImage, id)
        );
        Promise.all(imgs).then(res => {
          this.downloadCanvas();
        });
      },
      unInlineImages() {
        Object.keys(this.trayData).forEach(id => {
          if (this.trayData[id].backgroundTileImage) {
            document.getElementById(
              id
            ).style.backgroundImage = `url('${this.trayData[id].backgroundTileImage}')`;
          }
        });
      },
      // Start: Download option of compare products
      async downloadTrayImage() {
        if (!Object.keys(this.trayData).length) {
          this.showNoItemsForDownload();
          return;
        }
        let styleNumbers = [];
        Object.values(this.trayData).map(item => {
          styleNumbers = [...styleNumbers, item.sellingStyleNumber];
        });

        await this.fetchTrayDetails(styleNumbers.join())
          .then(async response => {
            await Object.values(this.trayData).map((item, index) => {
              item.productDetails = this.getComparedProductDataDownloadTray.filter(
                compItem => item.sellingStyleNumber == compItem.sellingStyleNumber
              )[0];
              this.$store.commit("virtualTray/updateTrayItem", {
                id: item.id,
                updatedItem: item
              });
            });

            await this.downloadCanvas();
            this.$store.commit("virtualTray/clearDownloadDataTrayData");
          })
          .catch(error => {
            console.error(error);
            return false;
          });
      },
      downloadCanvas() {
        html2canvas(document.querySelector("#outer-wrapper-vt"), {
          allowTaint: true,
          useCORS: true
        }).then(canvas => {


            const anchorToDwonload =  document.createElement('a')
            anchorToDwonload.setAttribute('href', canvas.toDataURL('image/png'));
            anchorToDwonload.setAttribute('download', this.trayId ?  this.boardDetails &&  this.boardDetails.boardDetails && this.boardDetails.boardDetails.title && String(this.boardDetails.boardDetails.title).replaceAll(".", '-').trim() :
              "Patcraft samples tray-" +
              `${new Date()
                .toJSON()
                .slice(0, 10)
                .split("-")
                .join("")}` +
              ".png")
            document.body.appendChild(anchorToDwonload);
            anchorToDwonload.click();

            setTimeout(() => {
              anchorToDwonload.remove();
            }, 0);
        });
      },
      unmouseStuff() {
        this.toggleSelectedTile("");
      },
      showModal(name) {
        this.$modal.show(name + "-modal");
      },
      hideModal(name) {
        this.$modal.hide(name + "-modal");
      },
      openFiltersModal() {
        this.setFiltersModalOpened(true);
        document.body.classList.add("vm--block-scroll");
      },
      closeFiltersModal() {
        this.hideModal("filters");
      },
      hideFiltersModal(event) {
        event.cancel();
        this.setFiltersModalOpened(false);
        document.body.classList.remove("vm--block-scroll");
      },
      openPremixesModal() {
        this.showModal("premixes");
      },
      closePremixesModal() {
        this.hideModal("premixes");
      },
      openSaveTrayDefault() {
        if (localStorage.getItem("saveTrayIsLoggedIn") == "true") {
          this.showModal("save-tray");
        }
      },
      openRemoveModal() {
        this.showModal("remove-item-confirm");
      },
      closeRemoveModal() {
        this.hideModal("remove-item-confirm");

      },
      closeRedirectModal() {
        this.hideModal("redirect-confirm");
        if (this.getselectedTray === "premixTray") {
          window.location.href = "/Account/MyTrays?tab=premix";
        } else if (this.getselectedTray !== "") {
          window.location.href = "/Account/MyTrays?tab=active";
        }
      },
      openStartOverModal() {
        this.showModal("start-over-confirm");
      },
      closeStartOverModal() {
        this.hideModal("start-over-confirm");
      },
      openPremixesConfirmModal() {
        this.showModal("premixes-confirm");
      },
      closePremixesConfirmModal() {
        this.hideModal("premixes-confirm");
      },
      openTooMuchAlertModal() {
        this.showModal("too-much-items-alert");
      },
      closeTooMuchAlertModal() {
        this.hideModal("too-much-items-alert");
      },
      confirmReplaceToPremix(premix) {
        this.premix = premix;
        this.openPremixesConfirmModal();
      },
      trayDeleteItem(id) {
        this.selectedId = id;
        if (localStorage.getItem("vtConfirmModalHide") == "true") {
          this.confirmRemove();
        } else {
          this.openRemoveModal();
        }
      },
      confirmRemove() {
        this.trayOrderDeleteItem(this.selectedId);
        this.trayDataDeleteItem(this.selectedId);
        if (this.trayId) {
          this.trayDataEditDeleteItem(this.selectedId);
          this.newDataDeltededFromTray(this.selectedId);
        }
        this.closeRemoveModal();
      },
      extractSamplesInfo: function (samplesInfo) {
        let extractedInfo = { width: 0, length: 0, vehicleId: 0 };
        let sizes = [];
        let areas = [];

        if (typeof samplesInfo === "undefined") return extractedInfo;
        for (const sample of samplesInfo) {
          if (sample.sizes.length > 0) {
            let width = sample.sizes[0].width.imperial.originalValue;
            let length = sample.sizes[0].length.imperial.originalValue;

            // address special cases
            if (width == 24 && length == 24) {
              width = 6;
              length = 12;
            } else if (width == 18 && length == 36) {
              width = 9;
              length = 12;
            }

            let size = {
              width: width,
              length: length,
              vehicleId: sample.vehicleId
            };
            let area = width * length;
            sizes[area] = size;
            areas.push(area);
          }
        }

        if (areas.length > 0) {
          const minArea = Math.min.apply(null, areas);
          extractedInfo = sizes[minArea];
        }

        return extractedInfo;
      },
      positionTile: function (event, item) {
        const currentEvent = event.type === "touchmove" ? event.touches[0] : event;
        const dropZoneRect = document.getElementById("dropzone")?.getBoundingClientRect();

        item.tileLeftOffset = currentEvent.clientX - (dropZoneRect.left + window.scrollX);
        item.tileTopOffset = currentEvent.clientY - (dropZoneRect.top + window.scrollY);
      },
      // Drag n Drop
      startDrag: function (id) {
        if (this.trayData[id]) {
          let tile = document.getElementById(id);
          this.toggleSelectedTile(id);
          this.dragging = id;
          this.trayOrderDeleteItem(id);

          // reset classes
          tile.classList.remove("dropped");
          tile.classList.add("raised");

          document.getElementById("outer-wrapper").classList.add("dragging");
        }
      },
      doDrag: function (event) {
        let id = this.dragging;
        if (id) {
          let tileData = this.trayData[id];
          let tile = document.getElementById(id); // ToDo: Probably want to phase this out
          this.positionTile(event, tileData);

          // update classes signifying if over particular zone
          let trayZone = document.getElementById("dropzone");
          let overTray = this.isTileInDropzone(id, "dropzone");

          trayZone.classList.remove("active");
          tile.classList.remove("over-tray", "outside-zone");
          if (overTray) {
            if (!trayZone.classList.contains("active"))
              trayZone.classList.add("active");
            if (!tile.classList.contains("over-tray"))
              tile.classList.add("over-tray");
          } else {
            if (!tile.classList.contains("outside-zone"))
              tile.classList.add("outside-zone");
          }
        }
      },
      isTileInDropzone(tileId, zoneId) {
        let inZone = true;
        let tile = document.getElementById(tileId);
        let tileRect = tile.getBoundingClientRect();
        let zone = document.getElementById(zoneId);
        let zoneRect = zone.getBoundingClientRect();

        if (tileRect.top < zoneRect.top) inZone = false;
        if (tileRect.left < zoneRect.left) inZone = false;
        if (tileRect.bottom > zoneRect.bottom) inZone = false;
        if (tileRect.right > zoneRect.right) inZone = false;

        return inZone;
      },
      stopDrag() {
        let id = this.dragging;
        let item = this.trayData[id];
        if (typeof item !== "undefined") {
          let tile = document.getElementById(id);
          tile.classList.remove("raised");
          tile.classList.add("dropped");
          this.dragging = "";

          // Validate tray is dropped inside drop zone
          if (this.isTileInDropzone(id, "dropzone")) { // Inside
            item.isFirstDrag = false;
            item.imageZIndex = this.getNewZIndex()

            // Updating last dropped XY
            item.lastDroppedTileLeftOffset = item.tileLeftOffset;
            item.lastDroppedTileTopOffset = item.tileTopOffset;
            item.lastDroppedImageZIndex = item.imageZIndex;
            document.getElementById(id).style.zIndex = item.imageZIndex

            this.trayOrderAddItem(id);
          }
          else { // Outside
            // If first drop means true
            if (item.isFirstDrag) {
              this.trayOrderDeleteItem(id);
              this.trayDataDeleteItem(id);
            }
            else {
              // Updating new drop XY with last dropped XY
              item.tileLeftOffset = item.lastDroppedTileLeftOffset;
              item.tileTopOffset = item.lastDroppedTileTopOffset;
              item.imageZIndex = item.lastDroppedImageZIndex;
              document.getElementById(id).style.zIndex = item.lastDroppedImageZIndex

              this.trayOrderAddItem(id);
            }
          }
        }
        document.getElementById("outer-wrapper").classList.remove("dragging");
      },
      confirmStartOver() {
        if (this.trayId) {
          window.location.href = "/virtualtray";
        }
        this.startOver();
        this.resetSearchCriterias();
        this.setPageNumber(1);
        this.closeStartOverModal();
      },
      trayDataPremixLoad(premixName) {
        window.l("loading " + premixName);
        const selectedPremix = this.premixes.find(
          premix =>
            premix &&
            premixName &&
            premix.name.toLowerCase() == premixName.toLowerCase()
        );
        if (!selectedPremix) return;
        let tempTray = selectedPremix;

        const mostLeftTileOffset = Math.min(
          ...Object.values(tempTray.data).map(value => value.tileLeftOffset)
        );

        const dropZoneRect = document
          .getElementById("dropzone")
          ?.getBoundingClientRect();
        const leftShift = mostLeftTileOffset - 50 - dropZoneRect.x;

        for (const property in tempTray.data) {
          let containerImage = this.$helpers.getItemBackgroundImage(
            tempTray.data[property],
            "tiles"
          );

          tempTray.data[property].backgroundTileImage = containerImage;
          tempTray.data[property].tileTopOffset -= 185;
          tempTray.data[property].tileLeftOffset += Math.abs(leftShift);
        }

        window.l(selectedPremix);
        window.l(premixName + " loaded");
        this.loadTray(tempTray);
        this.closePremixesModal();
      },
      processPremixClick() {
        const name = this.premix.name;
        this.trayDataPremixLoad(name);
        this.closePremixesConfirmModal();
      },
      getNewZIndex() {
        const max = Math.max(...Object.values(this.trayData).map(item => item.imageZIndex))
        return (max > -1) ? max + 1 : 0;
      },
      processSlideEvent: function (item) {
        if (this.trayId) {
          if (this.isCombinationAlreadyPresent(item)) {
            this.duplicateSwatchErrMsg(this.$resourceString["common.ProductAlreadyAdded.Msg"]);
            return;
          }
        } else {
          for (const trayItem of Object.values(this.trayData)) {
            if (item.styleNumber == trayItem.sellingStyleNumber && item.colorNumber == trayItem.colorNumber) {
              this.duplicateSwatchErrMsg(this.$resourceString["common.ProductAlreadyAdded.Msg"]);
              return;
            }
          }
        }

        this.modalShownBool = false
        const type = item.inventoryType;

        if (!this.isOkToAddMore(type)) {
          this.openTooMuchAlertModal();
          return;
        }

        let timestamp = new Date().getTime();
        let id = item.styleNumber + "_" + item.colorNumber + "_" + timestamp;
        let newItem = {};

        // On first drag
        newItem.isFirstDrag = true;

        let extractedInfo = this.extractSamplesInfo(item.samples);
        newItem.id = id;

        // Custom overrides for `swatch` size
        newItem.swatchWidth = extractedInfo.width > 0 ? extractedInfo.width : 2; // fallback for missingn sizes
        newItem.swatchLength =
          extractedInfo.length > 0 ? extractedInfo.length : 4; // fallback for missing sizes
        if (type.toUpperCase() === "POM") {
          // Override for POMs
          newItem.swatchWidth = 1;
          newItem.swatchLength = 1.625;
        } else if (type === "Paint") {
          newItem.swatchWidth = 1;
          newItem.swatchLength = 1.625;
          newItem.swatchWidth = 2.4;
          newItem.swatchLength = 3.6;
        } else if (
          item.styleNumber == "I337V" ||
          item.styleName.includes("METALLIX")
        ) {
          // fix for Metallix
          newItem.swatchWidth = 6;
          newItem.swatchLength = 8;
        }

        newItem.tileWidth = newItem.swatchWidth * this.swatchTileSizeRatio;
        newItem.tileHeight = newItem.swatchLength * this.swatchTileSizeRatio;

        newItem.tileLeftOffset = 0;
        newItem.tileTopOffset = 0;

        newItem.vehicleId = extractedInfo.vehicleId;
        newItem.imageZIndex = this.getNewZIndex();

        newItem.sellingStyleNumber = item.styleNumber;
        newItem.styleNumber = item.styleNumber;
        newItem.sellingStyleName = item.styleName;
        newItem.inventoryStyleNumber = item.inventoryStyleNumber;
        newItem.colorNumber = item.colorNumber;
        newItem.colorName = item.colorName;
        newItem.imagePath =
          item.inventoryType === "Pom"
            ? item.backgroundTileImage
            : item.inventoryType === "Paint"
              ? `#${item.hex}`
              : item.imagePath;
        newItem.hexColor = item.hex && `#${item.hex}`;
        newItem.backgroundTileImage = item.backgroundTileImage;
        newItem.inventoryType = item.inventoryType;
        newItem.productTypeDesc = item.productTypeDesc;
        newItem.productType = item.productType;
        newItem.pdmsLink = item.pdmsLink ? item.pdmsLink.replace("-sys", "") : ""; // Original links need this fix
        newItem.sampleAvailabilityQuantity = 1;
        newItem.collection = item?.collection;
        newItem.isRotated = false;

        this.trayDataAddItem({ id, newItem });
        this.trayOrderAddItem(id);
        if (this.trayId) {
          this.newDataAddedInTray({ id, newItem });
        }
        this.$nextTick(() => {
          this.startDrag(id);
        });
      },

      isCombinationAlreadyPresent: function (item) {
      const trayDataValues = Object.values(this.trayData);

      for (let i = 0; i < trayDataValues.length; i++) {
        const trayItem = trayDataValues[i];
        if (trayItem.sellingStyleNumber === item.styleNumber && trayItem.colorNumber === item.colorNumber) {
          return true;
        }
      }

      return false;
    },
      isOkToAddMore(type) {
        let paintCount = 0;
        let pomCount = 0;
        let tileCount = 0;
        let maxPaint = 2;
        let maxPoms = 2;
        let maxTiles = 10;

        for (var i in this.trayData) {
          let itemType = this.trayData[i].inventoryType;
          window.l("type: " + itemType);
          if (itemType === "Paint") paintCount++;
          if (itemType?.toUpperCase() === "POM") pomCount++;

          if (itemType === "Carpet" || itemType === "Resilient") tileCount++;
        }

        if ((type === "Carpet" || type === "Resilient") && tileCount >= maxTiles)
          return false;
        if (type === "Paint" && paintCount >= maxPaint) return false;
        if (type === "Pom" && pomCount >= maxPoms) return false;

        return true;
      },
      trayClientDataLoad() {
        if (this.boardDetails?.boardDetails) {

        } else {
          let localStorageStr = localStorage.getItem("tray");
          if (localStorageStr) {
            try {
              let localStorageVal = JSON.parse(localStorageStr);
              this.loadTray(localStorageVal);
            } catch (e) {
              window.l("An error occurred loading tray: " + e);
            }
          }
        }
      },
      downloadTrayJson() {
        let blob = new Blob([JSON.stringify(this.tray)], { type: "text/json" });
        let a = document.createElement("a");
        a.download = "tray.json";
        a.href = window.URL.createObjectURL(blob);
        a.dataset.downloadurl = ["text/json", a.download, a.href].join(":");
        a.click();
      },
      async onSearch() {
        const encodedSearchTerm = this.searchTerm?.trim();
        await this.fetchResults({
          filter: {
            ...this.selections,
            ...this.carbonFilters,
            OrderColumn: this.sortOrder,
            PageNumber: this.pageNumber,
            IncludeTotalResultCount: true,
            PageSize: this.pageSize,
            InStock: this.inStock,
            IsAscendingOrder: true,
            SearchTerm: encodedSearchTerm,
            FaceWeightMin: this.faceWeightMin,
            FaceWeightMax: this.faceWeightMax
          }
        });
        this.showLoaderOnTrayZone = false;
      },
      onLoadMore() {
        if (this.isFetching) {
          return;
        }
        this.setPageNumber(this.pageNumber + 1);
        this.onSearch();
      },
      loadPremixes() {
        this.fetchPremixes({
          filter: {
            inventoryType: "premix",
            pageSize: 100,
            orderColumn: "ColorNumber",
            isAscendingOrder: true
          },
          includefilters: false
        });
      }
    },
    computed: {
      ...mapGetters({
        items: "virtualTray/items",
        getitemsData: "virtualTray/getitemsData",
        trayData: "virtualTray/trayData",
        trayOrders: "virtualTray/trayOrders",
        isFiltersModalOpened: "virtualTray/isFiltersModalOpened",
        tray: "virtualTray/tray",
        searchTerm: "filters/searchTerm",
        selectedFilters: "filters/selectedFilters",
        inStock: "filters/inStock",
        pageNumber: "virtualTray/pageNumber",
        sortOrder: "filters/sortOrder",
        pageSize: "virtualTray/pageSize",
        isFetching: "virtualTray/isFetching",
        showLoadMore: "virtualTray/showLoadMore",
        faceWeightValue: "filters/faceWeightValue",
        filterByFaceWeight: "filters/filterByFaceWeight",
        carbonFilters: "filters/carbonFilters",
        selections: "filters/selections",
        faceWeightMin: "filters/faceWeightMin",
        faceWeightMax: "filters/faceWeightMax",
        premixes: "virtualTray/premixes",
        shareTrayId: "myTray/getShareTrayId",
        OrderSampleEnabled: "productDetail/getisOrderSampleEnabled",
        getComparedProductData: "myTray/getComparedProductData",
        getComparedProductDataDownloadTray:
          "myTray/getComparedProductDataDownloadTray",
          getselectedTray:"myTray/getselectedTray"
      }),
      changedData() {
        return `${this.selectedFilters}|${this.inStock}|${this.searchTerm}|${this.filterByFaceWeight}|${this.faceWeightValue}`;
      },
      showShareTrayButton() {
        return this.trayId !== null;
      },
      isDisabled() {
        return Object.keys(this.trayData)?.length === 0 || (this.boardDetails?.boardDetails?.status === 1);
      }
    },
    async mounted() {
      this.updateCommonErrorMsg(this.$resourceString["common.Error.Msg"]);
      this.httpReferer = document.referrer;
      if (this.trayId && Object.keys(this.trayData)?.length !== 0) {
        this.modalShownBool = false
      }
      if (this.boardDetails?.boardDetails) {

        let editData = this.boardDetails?.boardDetails?.sections.find(
          e => e.title == "default"
        );

        editData.contentItems.map(async (element) => {
          await element.productContentItem.productStyleImages.map(async (item) => {
            await this.fetchTrayDetails(element.productContentItem.productId);
            let timestamp = new Date().getTime();
            let id =
              element.productContentItem.productId +
              "_" +
              item.colorNumber +
              "_" +
              timestamp;
            let newItem = {};
            newItem.id = id;
            newItem.isFirstDrag = false;
            newItem.swatchWidth = item.swatchWidth;
            newItem.swatchLength = item.swatchLength;
            newItem.tileWidth = item.tileWidth;
            newItem.tileHeight = item.tileHeight;
            newItem.tileLeftOffset = item.tileLeftOffset;
            newItem.tileTopOffset = item.tileTopOffset;
            newItem.imageZIndex = item.imageYIndex;

            // Updating last dropped XY
            newItem.lastDroppedTileLeftOffset = item.tileLeftOffset;
            newItem.lastDroppedTileTopOffset = item.tileTopOffset;
            newItem.lastDroppedImageZIndex = item.imageYIndex;

            newItem.vehicleId = item.vehicleId;
            newItem.sellingStyleNumber = element.productContentItem.productId;
            newItem.colorNumber = item.colorNumber;
            newItem.colorName = item.colorName;
            newItem.imagePath = item.imageLink;
            newItem.productType = this.getComparedProductData.productType;
            newItem.hexColor = item.hexColor;
            newItem.backgroundTileImage = item.imageLink;
            newItem.inventoryType = item.inventoryType;
            newItem.pdmsLink = this.getComparedProductData.pdmsLink;
            newItem.styleName = this.getComparedProductData.sellingStyleName;
            newItem.sampleAvailabilityQuantity = 1;
            newItem.isRotated = item.imageXIndex === 1 ? true : false;
            newItem.productContentItemId = item.productContentItemId;
            newItem.imageId = item.id;
            newItem.collection = this.getComparedProductData?.collection;

            this.trayDataEditAddItem({ id, newItem });
            this.trayDataAddItem({ id, newItem });
            this.trayOrderAddItem(id);
          });
        })
      }
      this.showModal("filters");

      this.trayClientDataLoad();
      // this.openWelcomeModal();


      setTimeout(() => {
        document.body.classList.remove("vm--block-scroll");
      }, 500);

      this.loadPremixes();
    },
    created() {
      if (location.search) {
        this.setFiltersFromURL();
      } else {
        this.showLoaderOnTrayZone = true;
        this.onSearch();
      }
      this.isOrderSampleEnabled();

      window.l = this.l;
      if (location.search === "?admin") this.isAdminMode = true;
      if(this.boardDetails?.boardDetails?.id != null && this.boardDetails?.boardDetails?.id != undefined)
      {
        this.trayId = this.boardDetails?.boardDetails?.id;
        this.UpdatetrayEditId(this.trayId);
        document.body.onbeforeunload = (event) => {
          event.preventDefault();
          return "";
        };
      }
    },
    watch: {
      trayData: {
        handler: function () {
          let localStorageStr = JSON.stringify(this.tray);

          if(!this.trayId){
            localStorage.setItem("tray", localStorageStr);
          }
          if(Object.keys(this.trayData)?.length == 0){
            this.modalShownBool = true
          }
          else{
            this.modalShownBool = false
          }
        },
        deep: true

      },
      changedData: {
        handler: function () {
          this.setPageNumber(1);
          this.onSearch();
          this.setFiltersInURL("OriginalActivationDate");
        },
        deep: true
      }
    }
  };
</script>

<style scoped>
.mt-3.start-over.text-left.text-nowrap {
  width: 213px;
}

.hide-on-mobile-tablet {
  display: block;
}

/* CSS for screens with a maximum width of 768px (typical for tablets and mobiles) */
@media (max-width: 768px) {
  .hide-on-mobile-tablet {
    display: none;
  }
}
.bottom-container{
  margin: auto;
}
</style>
